<template>
    <!--
Test Browsers
    -->
    <div v-if="showAppDown">
        <div class="panel" align="center">
            <h4 class="redColoredText">
                Anwendung nicht verfügbar
            </h4>
            <p>
                Die Anwendung steht aktuell leider nicht zur Verfügung. Bitte versuchen Sie es später erneut.
            </p>
        </div>
    </div>
    <div v-else-if="isInitializationDone" class="panel" id="compensation-app">
        <span id="app-top"></span>
        <div class="progress radius">
            <span class="meter" v-bind:style="{ width: progress + '%' }"></span>
        </div>
        <div v-if="validation_error" id="validation_error">Bitte beantworten Sie die untenstehende Frage.</div>

        <form @submit.prevent="handleSubmit">
            <div v-if="step === 1">
                <h1>Seit wann arbeiten Sie bereits für Ihren Arbeitgeber?</h1>
                <div class="short_field"><input type="date" name="entry_date" v-model="fields.entry_date"></div>
                <button style="visibility: hidden" class="back button round">Zurück</button>
                <button class="next button round" @click.prevent="next(fields.entry_date)">Weiter</button>
            </div>

            <div v-if="step === 2">
                <h1>Beschäftigt Ihr Arbeitgeber regelmäßig mehr als {{ necessary_staff }} Mitarbeiter?</h1>
                <div class>
                    <ul class="button-group round even-2 text-center">
                        <li>
                            <button
                                v-bind:class="{ active: fields.is_large_company}"
                                @click.prevent="fields.is_large_company = true"
                                class="button info"
                            >Ja</button>
                        </li>
                        <li>
                            <button
                                v-bind:class="{ active: fields.is_large_company === false}"
                                @click.prevent="fields.is_large_company = false"
                                class="button info"
                            >Nein</button>
                        </li>
                    </ul>
                </div>

                <button class="back button round" @click.prevent="prev()">Zurück</button>
                <button class="next button round" @click.prevent="next(fields.is_large_company)">Weiter</button>
            </div>

            <div v-if="step === 3">
                <h1>Haben Sie Ihre Kündigung bereits erhalten?</h1>
                <div class="short_field radio_field">
                    <input type="radio" id="has_not_received_date" name="no_received_date" v-model="no_received_date" v-bind:value=true v-on:click="resetReceivedDate">
                    <label for="has_not_received_date" v-on:click="resetReceivedDate">Nein</label>
                    <input type="radio" id="has_received_date" name="no_received_date" v-model="no_received_date" v-bind:value=false>
                    <label for="has_received_date">Ja, am:</label>
                </div>
                <div class="short_field">
                    <input :disabled="no_received_date" type="date" name="begin_date" v-model="fields.received_date">
                </div>
                <button class="back button round" @click.prevent="prev()">Zurück</button>
                <button class="next button round" @click.prevent="next(no_received_date ? true : (!no_received_date && fields.received_date ? true : null))">Weiter</button>
            </div>

            <div v-if="step === 4">
                <h1>Ihr Monatsgehalt (brutto in €, nur Zahlen):</h1>
                <!-- Allow only number via charcodes -->
                <div class="short_field"><input type="number" name="salary" v-model="fields.salary" onkeypress="return event.charCode >= 48 && event.charCode <= 57" title="Nur Zahlen"></div>

                <button class="back button round" @click.prevent="prev()">Zurück</button>
                <button class="next button round" @click.prevent="next(fields.salary)">Weiter</button>
            </div>

            <div v-if="step === 5">
                <h1>Sind Sie rechtsschutzversichert?</h1>

                <ul class="button-group round even-2 text-center">
                    <li>
                        <button
                            v-bind:class="{ active: fields.has_rsv}"
                            @click.prevent="fields.has_rsv = true"
                            class="button info"
                        >Ja</button>
                    </li>
                    <li>
                        <button
                            v-bind:class="{ active: fields.has_rsv === false}"
                            @click.prevent="fields.has_rsv = false"
                            class="button info"
                        >Nein</button>
                    </li>
                </ul>

                <button class="back button round" @click.prevent="prev()">Zurück</button>
                <button class="next button round" @click.prevent="next(fields.has_rsv)">Weiter</button>
            </div>

            <div v-if="step === 6">
                <h1>Ihre E-Mail Adresse (für das Ergebnis)</h1>
                <div class="short_field"><input type="text" name="email" v-model="fields.email"></div>
                <button class="back button round" @click.prevent="prev()">Zurück</button>
                <button class="next button round" @click.prevent="next(fields.email)">Weiter</button>
            </div>

            <div v-if="step === 7 && !error">
                <h1>Ihre Telefonnummer (für kostenlose Ersteinschätzung)</h1>

                <div class="short_field"><input type="text" name="phone" v-model="fields.phone"></div>

                <button class="back button round" @click.prevent="prev()">Zurück</button>
                <button class="next button round" @click.prevent="handleSubmit(fields.phone)" type="submit" :disabled="submitting">
                    <span v-if="submitting">Wird gesendet...
                        <img src="./assets/loader.svg">
                    </span>
                    <span v-else>Weiter</span>
                </button>
            </div>

            <div v-if="step === 8">
                <h1>Vielen Dank!</h1>
                <p>Sie erhalten Ihre berechnete Abfindung sowie weitere Informationen in Kürze per E-Mail an die von Ihnen angegebene E-Mail Adresse. Sollten Sie noch weitere Fragen haben, erreichen Sie uns unter <a href="mailto: kuendigung@ratis.de">kuendigung@ratis.de</a>.</p>
            </div>

            <div v-if="error">
                <h1>Fehler!</h1>
                <p>Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich bei dauerhaften Problemen an <a href="mailto: kuendigung@ratis.de">kuendigung@ratis.de</a>.</p>
            </div>


        </form>
    </div>
</template>


<script>
import moment from "moment";
import Config from './constants/Config';
import CalculateCompensation from './api/calculateCompensation';
import Maintenance from './api/maintenance';

export default {
    data() {
        return {
            step: 1,
            nr_of_steps: 8, // maximum number of steps, used for progress bar
            trackingUrl: Config.TRACKING_URL,
            fields: {
                entry_date: null,
                received_date: null,
                is_large_company: null,
                salary: null,
                has_rsv: null,
                email: null,
                phone: null
            },
            no_received_date: true,
            submitted: false, // true when submitted
            submitting: false, // true while submitting,
            error: false, // true if error occured
            error_msg: '',
            validation_error: false,
            showAppDown: false,
            isInitializationDone: false
        };
    },

    components: {},
    computed: {
        progress: function() {
            return (100 / this.nr_of_steps) * this.step;
        },
        necessary_staff: function() { // necessary staff for Kündigungsschutz is only 5 before 31.12.2003
            if (moment(this.fields.begin_date).isBefore('2003-12-31')) {
                return 5;
            }
            else {
                return 10;
            }
        }
    },

    methods: {
        prev() {
            this.step--;
            this.validation_error = false; // reset validation error
        },
        next(field_value) {
            if(field_value === null || String(field_value) === '') {
                this.validation_error = true;
                return;
            }
            this.validation_error = false;
            this.step++;

        },
        async handleSubmit(field_value) {
            if(field_value == null || String(field_value) === '') {
                this.validation_error = true;
                return;
            }
            this.validation_error = false;
            this.submitting = true;

            try
            {
                let response = await CalculateCompensation.send(this.fields);

                if(response.success) {
                    this.submitted = true;
                    this.step++;
                }
                else {
                    this.error = true;
                    this.submitted = true;
                }
            }
            catch (error)
            {
                console.log(error);
                this.error = true;
                this.error_msg = error;
                this.submitted = true;
            }

            // Scroll to top of the app
            let top = document.getElementById("app-top");
            top.scrollIntoView({behavior: "smooth"});

            //this.createTrackingIframe();
            this.redirectToTracking();
        },
        //deprecated
        createTrackingIframe()
        {
          let iframe = document.createElement('iframe');
          iframe.setAttribute('id', 'trackingIframe');
          iframe.setAttribute('src', this.trackingUrl);
          iframe.style.display = "none";
          document.body.appendChild(iframe);
          let me = this;
          iframe.onload = () => me.removeTrackingIframe();
        },
        redirectToTracking()
        {
            setTimeout(() => {
                window.location.href = this.trackingUrl;
            }, 1000);
        },
        removeTrackingIframe()
        {
          let iframe = document.getElementById('trackingIframe');
          document.body.removeChild(iframe);
        },
        resetReceivedDate() {
            this.fields.received_date = null;
        },
        async checkHealth()
        {
            try
            {
                let response = await Maintenance.checkHealth();

                if (response.is_down)
                    this.showAppDown = true;
            }
            catch (error)
            {
                this.showAppDown = true;
            }
        }
    },
    async mounted()
    {
        await this.checkHealth();
        this.isInitializationDone = true;
    }
};
</script>


<style>
#compensation-app h1 {
    font-size: 1.3rem;
    line-height: 2rem;
    color: #333;
    text-align: center;
}

#compensation-app .short_field {
    max-width: 300px;
    min-width: 200px;
    margin: auto;
}

#compensation-app .radio_field {
  text-align: center;
}

#compensation-app .progress {
    height: 0.7rem;
}

#compensation-app .button-group {
    max-width: 500px;
    margin: auto;
}

#compensation-app button.next {
    float: right;
}

#compensation-app button.submit {
    float: right;
}

#compensation-app button {
    color: white;
    text-align: center;
}

#compensation-app button.active {
    background-color: #127198;
    color: white;
    font-weight: bold;
}

#compensation-app #validation_error {
    color: #cf2a0e;
    text-align: center
}

/* Remove red border on Chrome on focus */
#compensation-app button:focus {
    outline: none;
}

.redColoredText{
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/App.vue